var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _c("h1", [_vm._v(_vm._s(_vm.$t("Menu.RecordHistory")))]),
    _vm._v(" "),
    _vm.displayTasks
      ? _c(
          "div",
          { staticClass: "table-responsive sortable" },
          [
            _c("filter-input-row", {
              attrs: {
                title: "RecordHistory.Filter.Title",
                id: "recordhistoryfilter",
                filterFunction: _vm.filter,
                results: _vm.filteredTasks.length,
                resultsAriaText: "RecordHistory.Filter.ResultsAriaText"
              },
              model: {
                value: _vm.filterValue,
                callback: function($$v) {
                  _vm.filterValue = $$v
                },
                expression: "filterValue"
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "sr-only",
                attrs: { "aria-live": "assertive", "aria-atomic": "true" }
              },
              [_vm._v("\n      " + _vm._s(_vm.srSortedBy) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "table tablerow tasks-table sortable" },
              [
                _c("caption", [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("Menu.RecordHistory")) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pull-right sort-instructions" }, [
                    _vm._v(_vm._s(_vm.$t("Sort.Instructions")))
                  ])
                ]),
                _vm._v(" "),
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        staticClass: "w-15",
                        attrs: {
                          "aria-sort": _vm.ariaSortValue(
                            "date",
                            _vm.sortedBy,
                            _vm.sortedAsc
                          )
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sort",
                            on: {
                              click: function($event) {
                                _vm.displayTasks = _vm.sort(
                                  "date",
                                  _vm.filteredTasks
                                )
                              }
                            }
                          },
                          [
                            _c("sortable-header-button-content", {
                              attrs: {
                                title: "Date",
                                sortedBy: _vm.sortedBy,
                                sortProperty: "date",
                                sortedAsc: _vm.sortedAsc
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "w-10",
                        attrs: {
                          "aria-sort": _vm.ariaSortValue(
                            "target",
                            _vm.sortedBy,
                            _vm.sortedAsc
                          )
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sort",
                            on: {
                              click: function($event) {
                                _vm.displayTasks = _vm.sort(
                                  "target",
                                  _vm.filteredTasks
                                )
                              }
                            }
                          },
                          [
                            _c("sortable-header-button-content", {
                              attrs: {
                                title: "AidTargetNumber",
                                sortedBy: _vm.sortedBy,
                                sortProperty: "target",
                                sortedAsc: _vm.sortedAsc
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "w-10",
                        attrs: {
                          "aria-sort": _vm.ariaSortValue(
                            "year",
                            _vm.sortedBy,
                            _vm.sortedAsc
                          )
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sort",
                            on: {
                              click: function($event) {
                                _vm.displayTasks = _vm.sort(
                                  "year",
                                  _vm.filteredTasks
                                )
                              }
                            }
                          },
                          [
                            _c("sortable-header-button-content", {
                              attrs: {
                                title: "Year",
                                sortedBy: _vm.sortedBy,
                                sortProperty: "year",
                                sortedAsc: _vm.sortedAsc
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "w-30",
                        attrs: {
                          "aria-sort": _vm.ariaSortValue(
                            "subject",
                            _vm.sortedBy,
                            _vm.sortedAsc
                          )
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sort",
                            on: {
                              click: function($event) {
                                _vm.displayTasks = _vm.sort(
                                  "subject",
                                  _vm.filteredTasks
                                )
                              }
                            }
                          },
                          [
                            _c("sortable-header-button-content", {
                              attrs: {
                                title: "Subject",
                                sortedBy: _vm.sortedBy,
                                sortProperty: "subject",
                                sortedAsc: _vm.sortedAsc
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "w-15",
                        attrs: {
                          "aria-sort": _vm.ariaSortValue(
                            "state",
                            _vm.sortedBy,
                            _vm.sortedAsc
                          )
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sort",
                            on: {
                              click: function($event) {
                                _vm.displayTasks = _vm.sort(
                                  "state",
                                  _vm.filteredTasks
                                )
                              }
                            }
                          },
                          [
                            _c("sortable-header-button-content", {
                              attrs: {
                                title: "State",
                                sortedBy: _vm.sortedBy,
                                sortProperty: "state",
                                sortedAsc: _vm.sortedAsc
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("th", { staticClass: "w-20" }, [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.$t("Sr_Actions")))
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.items.length > 0
                  ? _c(
                      "tbody",
                      _vm._l(_vm.displayTasks, function(item, index) {
                        return _c("history-entry-table-row", {
                          key: index,
                          tag: "tr",
                          attrs: { item: item, index: index }
                        })
                      }),
                      1
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }